import axios from "axios";
import dayjs from "dayjs";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { v4 as uuidv4 } from "uuid";
import Spinner from "react-bootstrap/Spinner";
import Swal from "sweetalert2";

import {
  OverlayTrigger,
  Popover,
  Overlay,
  Modal,
  Toast,
} from "react-bootstrap";

import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { exportReportQuery } from "../static/reportQuery";
import CustomSpinner from "../components/CustomSpinner";

function StudentFunnel({
  serverURL,
  user,
  setShowSideOverlay,
  socket,
  logToUse,
  setLogToUse,
}) {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [ticketSubDepartmentRef, setticketSubDepartmentRef] = useState(null);
  const [totalStudents, setTotalStudents] = useState("");
  const [totalStudentsMark2, setTotalStudentsMark2] = useState("");
  const [allActive, setAllActive] = useState("");
  const [allPending, setAllPending] = useState("");

  const [selectedDate, setSelectedDate] = useState([]);
  const [dateOptions, setDateOptions] = useState([]);
  const [queryData, setQueryData] = useState(null);

  const [eventName, setEventName] = useState("");

  const [intake, setIntake] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [askSavedNow, setAskSavedNow] = useState(false)

  const [addComparisonTable, setAddComparisonTable] = useState(false);

  const [allDatesSelected, setAllDatesSelected] = useState(false);

  const [intakeOptions, setIntakeOptions] = useState(null);
  const [studentStatusOptions, setStudentStatusOptions] = useState([
    { value: "0", label: "Active" },
    { value: "1", label: "Hold" },
    { value: "2", label: "Drop" },
    { value: "3", label: "Alumni" },
    { value: "4", label: "InActive" },
    { value: "5", label: "Admission Deferred" },
    { value: "6", label: "Deferred Active" },
    { value: "7", label: "Ref / VIP" },
    { value: "8", label: "Refund" },
    { value: "9", label: "Hold Not Eligible" },
    { value: "10", label: "Hold payment Pending" },
    { value: "11", label: "Hold Not Responding" },
    { value: "12", label: "Hold Not Approved" },
  ]);
  const [locationOptions, setLocationOptions] = useState(null);
  const [categoryOptions, setCategoryOptions] = useState(null);
  const [packageOptions, setPackageOptions] = useState(null);
  const selectLocationOptions =
    locationOptions?.map((item) => ({
      label: item.LOCNAME,
      value: item.LOCCODE,
    })) || [];

  const fetchLocCode = async () => {
    try {
      const result = await axios.post(
        serverURL + "/mondayMeetings/generate-reports",
        {
          mstr: "SELECT DISTINCT locname, LocCode FROM locmas ORDER BY LocCode ASC",
          tokenNumber: "g@ba-ifth:6535",
        }
      );

      if (!result) {
        setLocationOptions([]);
      }

      setLocationOptions(result.data);
    } catch (error) {
      console.log(error);
    }
  };
  const [dataLoading, setDataLoading] = useState(false);
  const token = "g@ba-ifth:6535";
  const injectColumnData = (originalQuery, columnData) => {
    // Find the first FROM, capture everything after it
    const fromIndex = originalQuery.toUpperCase().indexOf("FROM");

    if (fromIndex === -1) {
      // No FROM clause, return as-is with SELECT only
      return `SELECT ${columnData}`;
    }

    // Get the rest of the query starting from FROM
    const afterFrom = originalQuery.slice(fromIndex);

    // Final query is SELECT + your columnData + original FROM...rest
    return `SELECT ${columnData} ${afterFrom}`;
  };
  const fetchDataByQuery = async (query, columnData, alertMsg) => {
    try {
      const modifiedQuery = injectColumnData(query, columnData);

      // console.log(modifiedQuery);
      const result = await Swal.fire({
        title: "Confirm to download?",
        text: alertMsg,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, download it!",
        cancelButtonText: "No, cancel",
      });

      if (!result.isConfirmed) {
        return; // Exit function if user cancels
      }
      const res = await axios.post(
        serverURL + "/mondayMeetings/generate-reports",
        {
          mstr: modifiedQuery,
          tokenNumber: token,
        }
      );
      console.log("this is fetchDataByQuery", res);
      if (res.status === 200 || res.status === 201) {
        setQueryData(res.data);
        handleDownload(res.data);
        console.log("this is fetchDataByQuery", res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const info = async () => {
    setDataLoading(true);
    const masterTables = [
      { label: "intake", value: "IntakeMas" },
      { label: "location", value: "LocMas" },
      { label: "category", value: "CatMas" },
      { label: "package", value: "PackageFeesMas" },
    ];
    const getAllInfo = await axios.post(
      serverURL + "/kpi/getMeCode",
      masterTables
    );
    if (getAllInfo.status === 200) {
      // console.log(getAllInfo.data)

      const filters = getAllInfo.data;

      let intakeData = await Promise.all(
        filters.intake.map(async (data, key) => {
          const query = {
            findCol: "IntakeCode",
            tableName: "StudentMas",
            value: data.IntakeCode,
          };
          const getBachhe = await axios.post(
            serverURL + "/kpi/getCountOfThis",
            query
          );
          if (getBachhe.status === 200) {
            // console.log(getBachhe.data)
            return {
              label: `${data.Intakename} (${getBachhe.data})`,
              value: data.IntakeCode,
            };
          } else {
            // console.log(getBachhe.data)
            return {
              label: `${data.Intakename} (${0})`,
              value: data.IntakeCode,
            };
          }
        })
      );

      let locationData = await Promise.all(
        filters.location.map(async (data, key) => {
          const query = {
            findCol: "LocCode",
            tableName: "StudentMas",
            value: data.LocCode,
          };
          const getBachhe = await axios.post(
            serverURL + "/kpi/getCountOfThis",
            query
          );
          if (getBachhe.status === 200) {
            // console.log(getBachhe.data)
            return {
              label: `${data.locname} (${getBachhe.data})`,
              value: data.LocCode,
            };
          } else {
            // console.log(getBachhe.data)
            return { label: `${data.locname} (${0})`, value: data.LocCode };
          }
        })
      );

      let categoryData = await Promise.all(
        filters.category.map(async (data, key) => {
          const query = {
            findCol: "CatCode",
            tableName: "StudentMas",
            value: data.CatCode,
          };
          const getBachhe = await axios.post(
            serverURL + "/kpi/getCountOfThis",
            query
          );
          if (getBachhe.status === 200) {
            // console.log(getBachhe.data)
            return {
              label: `${data.CatName} (${getBachhe.data})`,
              value: data.CatCode,
            };
          } else {
            // console.log(getBachhe.data)
            return { label: `${data.CatName} (${0})`, value: data.CatCode };
          }
        })
      );

      let packageData = await Promise.all(
        filters.package.map(async (data, key) => {
          const query = {
            findCol: "packagecode",
            tableName: "StudentMas",
            value: data.vno,
          };
          const getBachhe = await axios.post(
            serverURL + "/kpi/getCountOfThis",
            query
          );
          if (getBachhe.status === 200) {
            // console.log(getBachhe.data)
            return {
              label: `${data.Packagename} (${getBachhe.data})`,
              value: data.vno,
            };
          } else {
            console.log(getBachhe.data);
            return { label: `${data.Packagename} (${0})`, value: data.vno };
          }
        })
      );

      // console.log(intakeData,
      //   locationData,
      //   categoryData,
      //   packageData)

      setIntakeOptions(intakeData);
      setLocationOptions(locationData);
      setCategoryOptions(categoryData);
      setPackageOptions(packageData);
    } else {
      console.log(getAllInfo.data);
    }
  };

  const getNumbers = async (intk, locCode) => {
    setDataLoading(true);
    const query = {
      intakeCode: intk ? [intk.value] : null,
      locationCode: locCode,
    };

    const getTheValues = await axios.post(
      serverURL + "/mondayMeetings/get-monday-reports",
      query
    );
    if (getTheValues.status === 200) {
      // setTotalStudents(getTheValues.data)
      // console.log("getTheValues", getTheValues.data);
      setTotalStudents(getTheValues.data);
      setDataLoading(false);
    } else {
      console.log(getTheValues.data);
      setTotalStudents({});
      setDataLoading(false);
    }
  };

  const saveMondayMeetingData = async (e) => {
    e.preventDefault();
    const query = {
      uid: uuidv4(),
      data: totalStudents,
      date: dayjs().valueOf(),
      name: eventName,
      intake: intake.label ? intake.label.split(" (")[0] : "",
    };

    const saveDataNow = await axios.post(
      serverURL + "/mondayMeetings/saveMondayMeetingRecords",
      query
    );
    if (saveDataNow.status === 200) {
      console.log(saveDataNow.data);
      alert("Record Saved");
      getDateRecords();
    } else {
      console.log(saveDataNow.data);
    }
  };

  const getRecordByDate = async (dates) => {
    let ids = [];

    dates.map((date, key) => {
      ids.push(date.value);
    });

    const query = {
      uids: ids,
    };

    const saveDataNow = await axios.post(
      serverURL + "/mondayMeetings/getRecord",
      query
    );
    if (saveDataNow.status === 200) {
      // console.log(saveDataNow.data);

      setTotalStudentsMark2(saveDataNow.data);
    } else {
      console.log(saveDataNow.data);
    }
  };
  const getDateRecords = async () => {
    const getRecordDates = await axios.post(
      serverURL + "/mondayMeetings/getRecordDates"
    );
    if (getRecordDates.status === 200) {
      let records = [];

      // console.log(getRecordDates.data) 

      getRecordDates.data.map((record, key) => {
        records.push({
          label: record.name,
          value: record.uid,
          data: record
        });
      });

      setDateOptions(records);
    } else {
      console.log(getRecordDates.data);
    }
  };

  const handleDownload = (data) => {
    if (!data || data.length === 0) {
      return alert("No data found");
    }

    // Extract headers from the first object
    const headers = Object.keys(data[0]);

    // Convert array of objects to CSV format
    const csvContent = [
      headers.join(","), // CSV Header
      ...data.map((row) =>
        headers
          .map((field) =>
            row[field] !== null && row[field] !== undefined
              ? `"${row[field]}"`
              : ""
          )
          .join(",")
      ), // CSV Rows
    ].join("\n");

    // Create a Blob from the CSV content
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a link and trigger the download
    const a = document.createElement("a");
    a.href = url;
    a.download = "streport.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  useEffect(() => {
    if (selectedDate) {
      getRecordByDate(selectedDate);
    }
  }, [selectedDate]);


  const handleAllDatesSelection = (isAllSelected) => {
    if (isAllSelected) {
      const checkBoxes = document.querySelectorAll(".tableCompareClass");
      checkBoxes.forEach((checkbox) => {
        checkbox.checked = true;
        setSelectedDate(dateOptions);
      });
    } else {
      const checkBoxes = document.querySelectorAll(".tableCompareClass");
      checkBoxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
      setSelectedDate([]);
    }
  }


  const [askToDeleteTableRecord, setAskToDeleteTableRecord] = useState(false);
  const [idToDeleteTable, setIdToDeleteTable] = useState(null);

  const handleDeleteDate = async (uid) => {
    if (!uid) return;

    const deleteNow = await axios.post(serverURL + "/mondayMeetings/deleteRecord", { uid: uid });
    if (deleteNow.status === 200) {
      console.log(deleteNow.data);
      getDateRecords();
      setSelectedDate(selectedDate?.filter((dat) => { return dat.value !== uid }))
      setAskToDeleteTableRecord(false)
    } else {
      console.log(deleteNow.data);
    }
  }

  useEffect(() => {
    getNumbers(intake, selectedLocation?.value);
  }, [intake, selectedLocation]);

  useEffect(() => {
    info();
    getDateRecords();
    fetchLocCode();
  }, []);

  return (
    <>
      <div className="h-100 d-flex flex-column p-3">
        {
          user ?
            <>
              <button
                className="btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2"
                onClick={() => {
                  setShowSideOverlay(true);
                }}
              >
                <MenuIcon />
              </button>
              <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                <span>Student Funnel</span>
                <div
                  className="d-flex gap-2 align-items-center justify-content-center text-dark px-2"
                  style={{ cursor: "pointer" }}
                  title={"Name: " + user?.name + "\nEmail: " + user?.email}
                >
                  <i className="fa fa-user"></i>
                  <span>{user?.name}</span>
                </div>
              </div>
            </>
            :
            ""
        }

        <div className={`w-100 h-100 overflow-auto d-flex flex-column gap-2`}>
          <div className="d-flex gap-2 justify-content-between align-items-streach w-100">
            <div className="w-100 d-flex flex-wrap align-items-center gap-2 position-relative">
              <div className="w-100" style={{ maxWidth: "300px", position: "relative", zIndex: 999 }}>
                <Select
                  isDisabled={intakeOptions ? false : true}
                  className="w-100"
                  value={intake}
                  onChange={setIntake}
                  options={intakeOptions}
                  placeholder="Select Intake"
                  isClearable
                />
              </div>
              <div className="w-100" style={{ maxWidth: "300px", position: "relative", zIndex: 999 }}>
                <Select
                  isDisabled={intakeOptions ? false : true}
                  className="w-100"
                  value={selectedLocation}
                  onChange={setSelectedLocation}
                  options={locationOptions}
                  placeholder="Select Location.. "
                  isClearable
                />
              </div>

              <button
                className="btn btn-sm btn-dark rounded-3 w-100 px-3"
                style={{ maxWidth: "max-content" }}
                onClick={() => {
                  setAskSavedNow(true);
                }}
              >
                Save Table
              </button>
              <button className="btn btn-dark btn-sm rouded" onClick={() => { setAddComparisonTable(!addComparisonTable) }}>
                <i className="fa fa-plus"></i>
              </button>
            </div>
          </div>

          <div>
            <div
              className="w-100 my-3"
              style={{ maxWidth: "300px", position: "relative", zIndex: 999 }}
            >
              <Select
                className='w-100 d-none'
                placeholder="Add Comparisons"
                value={selectedDate}
                onChange={setSelectedDate}
                autoFocus={false}
                isMulti={true}
                isSearchable={true}
                required={false}
                options={dateOptions}
              />
            </div>
          </div>

          <div className={`w-100 h-100 overflow-auto`}>
            {dataLoading ? (
              <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                <CustomSpinner size={1} />
              </div>
            ) : (
              <table className="table table-bordered table-yesgermany table-custom-alignment w-100 m-0 shadow text-nowrap" style={{ maxWidth: "500px" }}>
                <thead className="sticky-top" style={{ zIndex: 1 }}>
                  <tr align="center">
                    <th
                      colSpan={3}
                      style={{ background: "#ffce00" }}
                    >
                      <p className="d-flex align-items-center justify-content-center gap-2 m-0 ">
                        Live Data As Per ERP
                      </p>
                    </th>

                    {
                      totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <th
                              key={key}
                              width="1%"
                              rowSpan={200}
                              valign="middle"
                              style={{
                                background: "silver",
                                writingMode: "vertical-rl",
                              }}
                            >
                              {/* Record {key + 1} */}
                            </th>
                            <th colSpan={2} style={{ background: "#ffce00", position: "relative" }}>
                              {record
                                ? record.name
                                  ? record.name
                                  : "All Intakes"
                                : "All Intakes"}
                              {/* <p className="text-nowrap m-0">
                                (
                                {record
                                  ? record.createdAt
                                    ? dayjs(record.createdAt).format(
                                      "DD MMMM YYYY h:mma"
                                    )
                                    : "All Intakes"
                                  : "All Intakes"}
                                )
                              </p> */}

                              {console.log(record)}
                              <button className="tableRecordKokatneWalaButton" onClick={() => {
                                setSelectedDate(selectedDate?.filter((dat) => { return dat.value !== record.uid }))
                              }}>
                                <i className="fa fa-times"></i>
                              </button>
                            </th>
                          </>
                        );
                      })}
                  </tr>
                  <tr style={{ background: "#ffce00" }}>
                    <th>Label</th>
                    <td>Total</td>
                    <td>Active</td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <th>Total</th>
                            <th>Active</th>
                          </>
                        );
                      })}
                  </tr>
                  {/* Total students */}
                  <tr>
                    <th className="text-nowrap">
                      {intake?.label ? intake.label : "All Intakes"}
                    </th>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents?.finalQueryTotal?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download Total Students report"
                        )
                      }
                    >
                      {totalStudents?.finalQueryTotal?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents?.totalActiveQuery?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download Active Students report"
                        )
                      }
                    >
                      {totalStudents?.totalActiveQuery?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td className="text-nowrap">
                              {record.data?.finalQueryTotal?.count}
                            </td>
                            <td className="text-nowrap">
                              {record.data.totalActiveQuery?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>
                </thead>

                <tbody>
                  {/* Onboarding call done */}
                  <tr>
                    <td className="text-nowrap">Onboarding Calls Done</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.onBoardingQuery.query,
                          exportReportQuery.onboardingCallsDoneReport.total,
                          "Do you want to download Total Onbording Calls done report"
                        )
                      }
                    >
                      {totalStudents.onBoardingQuery?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.onBoardingActiveQuery.query,
                          exportReportQuery.onboardingCallsDoneReport.total,
                          "Do you want to download Active Onbording Calls done report"
                        )
                      }
                    >
                      {totalStudents.onBoardingActiveQuery?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td
                              width="1%"
                              rowSpan={200}
                              valign="middle"
                              style={{
                                background: "silver",
                                writingMode: "vertical-rl",
                              }}
                            >
                            </td>
                            <td className="text-nowrap">
                              {record.data.onBoardingQuery?.count}
                            </td>
                            <td className="text-nowrap">
                              {record.data.onBoardingActiveQuery?.count}
                            </td>

                          </>
                        );
                      })}
                  </tr>

                  <tr>
                    <td
                      colSpan={3}
                      className="py-1 "
                      style={{ background: "#f9f9f9" }}
                    ></td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td
                              colSpan={2}
                              className="py-1 "
                              style={{ background: "#f9f9f9" }}
                            ></td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Drop + Refund */}
                  <tr>
                    <th className="text-nowrap text-danger">Drop + Refund</th>
                    <td
                      className="cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalDropRegistrationPaid.query,
                          exportReportQuery.registrationPaidReport.total,
                          "Do you want to download Drop & Refund report"
                        )
                      }
                    >
                      {totalStudents.totalDropRegistrationPaid?.count}
                    </td>
                    <td className="text-nowrap"></td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td className="text-nowrap">
                              {record.data.totalDropRegistrationPaid?.count}
                            </td>
                            <td className="text-nowrap">
                              {record.data.allRefundRegistrationPaid?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Hold - registration paid */}
                  <tr>
                    <td className="text-nowrap">HOLD - Registration Paid</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalHoldRegistrationPaid.query,
                          exportReportQuery.registrationPaidReport.total,
                          "Do you want to download Hold registration paid report"
                        )
                      }
                    >
                      {totalStudents.totalHoldRegistrationPaid?.count}
                    </td>
                    <td></td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td className="text-nowrap">
                              {record.data.totalHoldRegistrationPaid?.count}
                            </td>
                            <td></td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Hold - registration not paid */}
                  <tr>
                    <td className="text-nowrap">
                      HOLD - Registration Not Paid
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalHoldRegistrationNotPaid.query,
                          exportReportQuery.registrationPaidReport.total,
                          "Do you want to download hold registration not paid report"
                        )
                      }
                    >
                      {totalStudents.totalHoldRegistrationNotPaid?.count}
                    </td>
                    <td></td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td className="text-nowrap">
                              {record.data.totalHoldRegistrationNotPaid?.count}
                            </td>
                            <td></td>
                          </>
                        );
                      })}
                  </tr>

                  <tr>
                    <td
                      colSpan={3}
                      className="py-1 "
                      style={{ background: "#f9f9f9" }}
                    ></td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td
                              colSpan={2}
                              className="py-1 "
                              style={{ background: "#f9f9f9" }}
                            ></td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Registration Paid */}
                  <tr>
                    <th className="text-nowrap">Registration Paid</th>
                    <td
                      className="cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalRegistrationPaid.query,
                          exportReportQuery.registrationPaidReport.total,
                          "Do you want to download registration paid report"
                        )
                      }
                    >
                      {totalStudents.totalRegistrationPaid?.count}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalActiveRegistrationPaid.query,
                          exportReportQuery.registrationPaidReport.total,
                          "Do you want to download Active registration paid report"
                        )
                      }
                    >
                      {totalStudents.totalActiveRegistrationPaid?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td className="text-nowrap">
                              {record.data.totalRegistrationPaid?.count}
                            </td>
                            <td className="text-nowrap">
                              {record.data.totalActiveRegistrationPaid?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Temp final CV */}
                  <tr>
                    <td className="text-nowrap">Temp Final CV</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totaltempfinalCV?.query,
                          exportReportQuery.cvReport.total,
                          "Do you want to download temp final CV report"
                        )
                      }
                    >
                      {totalStudents.totaltempfinalCV?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totaltempfinalCVActive?.query,
                          exportReportQuery.cvReport.total,
                          "Do you want to download active temp final CV report"
                        )
                      }
                    >
                      {totalStudents.totaltempfinalCVActive?.count}
                    </td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totaltempfinalCV?.count}</td>
                            <td>{record.data.totaltempfinalCVActive?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Final CV */}
                  <tr>
                    <td className="text-nowrap">Final CV</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalCV?.query,
                          exportReportQuery.cvReport.total,
                          "Do you want to download final CV report"
                        )
                      }
                    >
                      {totalStudents.totalCV?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalCVActive?.query,
                          exportReportQuery.cvReport.total,
                          "Do you want to download active final CV report"
                        )
                      }
                    >
                      {totalStudents.totalCVActive?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalCV?.count}</td>
                            <td>{record.data.totalCVActive?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Reviewed & Document Pending */}
                  <tr>
                    <td className="text-nowrap">Reviewed & Document Pending</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalRegistrationPaidDocPending?.query,
                          exportReportQuery.cvReport.total,
                          "Do you want to download reviewed & document pending report"
                        )
                      }
                    >
                      {totalStudents.totalRegistrationPaidDocPending?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeRegistrationPaidDocPending?.query,
                          exportReportQuery.cvReport.total,
                          "Do you want to download active reviewed & document pending report"
                        )
                      }
                    >
                      {totalStudents.activeRegistrationPaidDocPending?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {
                                record.data.totalRegistrationPaidDocPending
                                  ?.count
                              }
                            </td>
                            <td>
                              {
                                record.data.activeRegistrationPaidDocPending
                                  ?.count
                              }
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Reviewed & APS Pending */}
                  <tr>
                    <td className="text-nowrap">Reviewed & APS Pending</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalRegistrationPaidFeePending?.query,
                          exportReportQuery.cvReport.total,
                          "Do you want to download review & APS pending report"
                        )
                      }
                    >
                      {totalStudents.totalRegistrationPaidFeePending?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeRegistrationPaidFeePending?.query,
                          exportReportQuery.cvReport.total,
                          "Do you want to download active review & APS pending report"
                        )
                      }
                    >
                      {totalStudents.totalRegistrationPaidFeePending?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {
                                record.data.totalRegistrationPaidFeePending
                                  ?.count
                              }
                            </td>
                            <td>
                              {
                                record.data.activeRegistrationPaidFeePending
                                  ?.count
                              }
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* APS applied */}
                  <tr>
                    <td className="text-nowrap">APS Applied</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAPSApplied?.query,
                          exportReportQuery.aps_applied.total,
                          "Do you want to download APS Applied report"
                        )
                      }
                    >
                      {totalStudents.totalAPSApplied?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAPSApplied?.query,
                          exportReportQuery.aps_applied.total,
                          "Do you want to download active APS Applied report"
                        )
                      }
                    >
                      {totalStudents.activeAPSApplied?.count}
                    </td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalAPSApplied?.count}</td>
                            <td>{record.data.totalAPSAppliedActive?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* APS rejected */}
                  <tr>
                    <td className="text-nowrap text-danger">APS Rejected</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAPSRejeted?.query,
                          exportReportQuery.aps_applied.total,
                          "Do you want to download APS rejected report"
                        )
                      }
                    >
                      {totalStudents.totalAPSRejeted?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAPSRejeted?.query,
                          exportReportQuery.aps_applied.total,
                          "Do you want to download active APS rejectedreport"
                        )
                      }
                    >
                      {totalStudents.activeAPSRejeted?.count}
                    </td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalAPSApplied?.count}</td>
                            <td>{record.data.totalAPSAppliedActive?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* APS recieved */}
                  <tr>
                    <td className="text-nowrap">APS Recieved</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAPSRecieved?.query,
                          exportReportQuery.aps_applied.total,
                          "Do you want to download APS Recieved report"
                        )
                      }
                    >
                      {totalStudents.totalAPSRecieved?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAPSRecieved?.query,
                          exportReportQuery.aps_applied.total,
                          "Do you want to download active APS Recieved report"
                        )
                      }
                    >
                      {totalStudents.activeAPSRecieved?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalAPSRecieved?.count}</td>
                            <td>{record.data.totalAPSRecievedActive?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  <tr>
                    <td
                      colSpan={3}
                      className="py-1 "
                      style={{ background: "#f9f9f9" }}
                    ></td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td
                              colSpan={2}
                              className="py-1 "
                              style={{ background: "#f9f9f9" }}
                            ></td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Registration Paid - Admission Cases */}
                  <tr>
                    <th className="text-nowrap">
                      Registration Paid - Admission Cases
                    </th>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalRegPaidAdmissionCases?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download Registration Paid - Admission Cases report"
                        )
                      }
                    >
                      {totalStudents.totalRegPaidAdmissionCases?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeRegPaidAdmissionCases?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download active Registration Paid - Admission Cases report"
                        )
                      }
                    >
                      {totalStudents.activeRegPaidAdmissionCases?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalRegPaidAdmissionCases?.count}
                            </td>
                            <td>
                              {record.data.activeRegPaidAdmissionCases?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* CL Shared */}
                  <tr>
                    <td className="text-nowrap">CL Shared</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalClShared?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download CL Shared report"
                        )
                      }
                    >
                      {totalStudents.totalClShared?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeClShared?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download active CL Shared report"
                        )
                      }
                    >
                      {totalStudents.activeClShared?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalClShared?.count}</td>
                            <td>{record.data.activeClShared?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* CL All Final */}
                  <tr>
                    <td className="text-nowrap">CL All Final</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalClFinal?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download CL all final report"
                        )
                      }
                    >
                      {totalStudents.totalClFinal?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeClFinal?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download active CL all final report"
                        )
                      }
                    >
                      {totalStudents.activeClFinal?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalClFinal?.count}</td>
                            <td>{record.data.activeClFinal?.count}</td>
                          </>
                        );
                      })}
                  </tr>
                  {/* CL All Final */}
                  <tr>
                    <td className="text-nowrap">CL Completely Finalized</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalClOnlyFinal?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download CL Full finalized report"
                        )
                      }
                    >
                      {totalStudents.totalClOnlyFinal?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeClOnlyFinal?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download active CL Full finalized report"
                        )
                      }
                    >
                      {totalStudents.activeClOnlyFinal?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalClFinal?.count}</td>
                            <td>{record.data.activeClFinal?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Admission Applied */}
                  <tr>
                    <td className="text-nowrap">Admission Applied</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmissionApplied?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download admission applied report"
                        )
                      }
                    >
                      {totalStudents.totalAdmissionApplied?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmissionApplied?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download active admission applied report"
                        )
                      }
                    >
                      {totalStudents.activeAdmissionApplied?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalAdmissionApplied?.count}</td>
                            <td>{record.data.activeAdmissionApplied?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Admission Given */}
                  <tr>
                    <td className="text-nowrap">Admission Given</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmissionGiven?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download admission given report"
                        )
                      }
                    >
                      {totalStudents.totalAdmissionGiven?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmissionGiven?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download active admission given report"
                        )
                      }
                    >
                      {totalStudents.activeAdmissionGiven?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalAdmissionGiven?.count}</td>
                            <td>{record.data.activeAdmissionGiven?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Public Univ Non Paid */}
                  <tr>
                    <td className="text-nowrap text-end">
                      Public Univ Non Paid
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmissionGivenPublicUniv?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download public univ non-paid report"
                        )
                      }
                    >
                      {totalStudents.totalAdmissionGivenPublicUniv?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmissionGivenPublicUniv?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download active public univ non-paid report"
                        )
                      }
                    >
                      {totalStudents.activeAdmissionGivenPublicUniv?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalAdmissionGivenPublicUniv?.count}
                            </td>
                            <td>
                              {
                                record.data.activeAdmissionGivenPublicUniv
                                  ?.count
                              }
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Other Category */}
                  <tr>
                    <td className="text-nowrap text-end">Other Category</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmissionGivenOtherCat?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download other category report"
                        )
                      }
                    >
                      {totalStudents.totalAdmissionGivenOtherCat?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmissionGivenOtherCat?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download active other category report"
                        )
                      }
                    >
                      {totalStudents.activeAdmissionGivenOtherCat?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalAdmissionGivenOtherCat?.count}
                            </td>
                            <td>
                              {record.data.activeAdmissionGivenOtherCat?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* 2nd YG paid */}
                  <tr>
                    <td className="text-nowrap">
                      2<sup>nd</sup> YG Paid
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.total2ndYgPaid?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download 2nd YG paid report"
                        )
                      }
                    >
                      {totalStudents.total2ndYgPaid?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.active2ndYgPaid?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download active 2nd YG paid report"
                        )
                      }
                    >
                      {totalStudents.active2ndYgPaid?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.total2ndYgPaid?.count}</td>
                            <td>{record.data.active2ndYgPaid?.count}</td>
                            {/* <td>{record.data.pending2ndYgPaid?.count}</td> */}
                          </>
                        );
                      })}
                  </tr>

                  {/* Admission Accepted */}
                  <tr>
                    <td className="text-nowrap">Admission Accepted</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmissionAccepted?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download admission accepted report"
                        )
                      }
                    >
                      {totalStudents.totalAdmissionAccepted?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmissionAccepted?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download active admission accepted report"
                        )
                      }
                    >
                      {totalStudents.activeAdmissionAccepted?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalAdmissionAccepted?.count}</td>
                            <td>
                              {record.data.activeAdmissionAccepted?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  <tr>
                    <td
                      colSpan={3}
                      className="py-1 "
                      style={{ background: "#f9f9f9" }}
                    ></td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td
                              colSpan={2}
                              className="py-1 "
                              style={{ background: "#f9f9f9" }}
                            ></td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Total Applications */}
                  <tr>
                    <th className="text-nowrap">Total Applications</th>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalApplication?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download total application report"
                        )
                      }
                    >
                      {totalStudents.totalApplication?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeApplication?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active total application report"
                        )
                      }
                    >
                      {totalStudents.activeApplication?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalApplication?.count}</td>
                            <td>{record.data.activeApplication?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* In Process */}
                  <tr>
                    <td>In Process</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalInProcess?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download application in process report"
                        )
                      }
                    >
                      {totalStudents.totalInProcess?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeInProcess?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active application in process report"
                        )
                      }
                    >
                      {totalStudents.activeInProcess?.count}
                    </td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalInProcess?.count}</td>
                            <td>{record.data.activeInProcess?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Pending */}
                  <tr>
                    <td className="text-danger">Pending</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalInPending?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download pending application report"
                        )
                      }
                    >
                      {totalStudents.totalInPending?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeInPending?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active pending application report"
                        )
                      }
                    >
                      {totalStudents.activeInPending?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalInPending?.count}</td>
                            <td>{record.data.activeInPending?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* SOP Uploaded (Pending + In Process) */}
                  <tr>
                    <td>SOP Uploaded (Pending + In Process)</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalSopUploaded?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download SOP uploaded report"
                        )
                      }
                    >
                      {totalStudents.totalSopUploaded?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeSopUploaded?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active SOP uploaded report"
                        )
                      }
                    >
                      {totalStudents.activeSopUploaded?.count}
                    </td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalSopUploaded?.count}</td>
                            <td>{record.data.activeSopUploaded?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Cancelled */}
                  <tr>
                    <td className="text-danger text-end">Cancelled</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalCancelled?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download cancelled application report"
                        )
                      }
                    >
                      {totalStudents.totalCancelled?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeCancelled?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active cancelled application report"
                        )
                      }
                    >
                      {totalStudents.activeCancelled?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalCancelled?.count}</td>
                            <td>{record.data.activeCancelled?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Applied */}
                  <tr>
                    <td>Applied</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalApplied?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download applied application report"
                        )
                      }
                    >
                      {totalStudents.totalApplied?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeApplied?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active applied application report"
                        )
                      }
                    >
                      {totalStudents.activeApplied?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalApplied?.count}</td>
                            <td>{record.data.activeApplied?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Admission Given */}
                  <tr>
                    <td className="text-end">Admission Given</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmissionRecieved?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download admission given report"
                        )
                      }
                    >
                      {totalStudents.totalAdmissionRecieved?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmissionRecieved?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active admission given report"
                        )
                      }
                    >
                      {totalStudents.activeAdmissionRecieved?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalAdmissionRecieved?.count}</td>
                            <td>
                              {record.data.activeAdmissionRecieved?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Public */}
                  <tr>
                    <td className="text-end">Public</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalPublicApplied?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download public admission given report"
                        )
                      }
                    >
                      {totalStudents.totalPublicApplied?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activePublicApplied?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active public admission given report"
                        )
                      }
                    >
                      {totalStudents.totalPublicApplied?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalPublicApplied?.count}</td>
                            <td>{record.data.activePublicApplied?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Total Rejected */}
                  <tr>
                    <td className="text-end">Total Rejected</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmissionRejected?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download rejected application report"
                        )
                      }
                    >
                      {totalStudents.totalAdmissionRejected?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmissionRejected?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active rejected application report"
                        )
                      }
                    >
                      {totalStudents.activeAdmissionRejected?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalAdmissionRejected?.count}</td>
                            <td>
                              {record.data.activeAdmissionRejected?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Private */}
                  <tr>
                    <td className="text-end">Private</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalPrivate?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download private application report"
                        )
                      }
                    >
                      {totalStudents.totalPrivate?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activePrivate?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active private application report"
                        )
                      }
                    >
                      {totalStudents.activePrivate?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalPrivate?.count}</td>
                            <td>{record.data.activePrivate?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Admission final - public */}
                  <tr>
                    <td>Admission Final - Public</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmissionGivenPublic?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download admission final public report"
                        )
                      }
                    >
                      {totalStudents.totalAdmissionGivenPublic?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmissionGivenPublic?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active admission final public report"
                        )
                      }
                    >
                      {totalStudents.activeAdmissionGivenPublic?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalAdmissionGivenPublic?.count}
                            </td>
                            <td>
                              {record.data.activeAdmissionGivenPublic?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Admission final - private */}
                  <tr>
                    <td>Admission Final - Private</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmissionGivenPrivate?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download admission final private report"
                        )
                      }
                    >
                      {totalStudents.totalAdmissionGivenPrivate?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmissionGivenPrivate?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download active admission final private report"
                        )
                      }
                    >
                      {totalStudents.activeAdmissionGivenPrivate?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalAdmissionGivenPrivate?.count}
                            </td>
                            <td>
                              {record.data.activeAdmissionGivenPrivate?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Fee Paid */}
                  <tr>
                    <td>Fee Paid - Private</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalFeePaid?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download fee paid report"
                        )
                      }
                    >
                      {totalStudents.totalFeePaid?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeFeePaid?.query,
                          exportReportQuery.total_application.total,
                          "Do you want to download CL Shared report"
                        )
                      }
                    >
                      {totalStudents.activeFeePaid?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalFeePaid?.count}</td>
                            <td>{record.data.activeFeePaid?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  <tr>
                    <td
                      colSpan={3}
                      className="py-1 "
                      style={{ background: "#f9f9f9" }}
                    ></td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td
                              colSpan={2}
                              className="py-1 "
                              style={{ background: "#f9f9f9" }}
                            ></td>
                          </>
                        );
                      })}
                  </tr>

                  {/* 2nd YG Paid - Visa Cases */}
                  <tr>
                    <th>2nd YG Paid - Visa Cases</th>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.total2ndYGPaidVisaCases?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download 2nd YG paid visa cases report"
                        )
                      }
                    >
                      {totalStudents.total2ndYGPaidVisaCases?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.active2ndYGPaidVisaCases?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download active 2nd YG paid visa cases report"
                        )
                      }
                    >
                      {totalStudents.active2ndYGPaidVisaCases?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.total2ndYGPaidVisaCases?.count}
                            </td>
                            <td>
                              {record.data.active2ndYGPaidVisaCases?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Partial filled */}
                  <tr>
                    <td>Partially Filled</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalPartiallyFilled?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download partially filled report"
                        )
                      }
                    >
                      {totalStudents.totalPartiallyFilled?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activePartiallyFilled?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download active partially filled report"
                        )
                      }
                    >
                      {totalStudents.activePartiallyFilled?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalPartiallyFilled?.count}</td>
                            <td>{record.data.activePartiallyFilled?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* File Launched */}
                  <tr>
                    <td>File Launched</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalFileLaunched?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download file launched report"
                        )
                      }
                    >
                      {totalStudents.totalFileLaunched?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeFileLaunched?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download active file launched report"
                        )
                      }
                    >
                      {totalStudents.activeFileLaunched?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalFileLaunched?.count}</td>
                            <td>{record.data.activeFileLaunched?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Visa Booked */}
                  <tr>
                    <td>Visa Booked</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalVisaBooked?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download visa booked report"
                        )
                      }
                    >
                      {totalStudents.totalVisaBooked?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeVisaBooked?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download active visa booked report"
                        )
                      }
                    >
                      {totalStudents.activeVisaBooked?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalVisaBooked?.count}</td>
                            <td>{record.data.activeVisaBooked?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Visa Applied */}
                  <tr>
                    <td>Visa Applied</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalVisaApplied?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download visa applied report"
                        )
                      }
                    >
                      {totalStudents.totalVisaApplied?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeVisaApplied?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download active visa applied report"
                        )
                      }
                    >
                      {totalStudents.activeVisaApplied?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalVisaApplied?.count}</td>
                            <td>{record.data.activeVisaApplied?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Visa Approved */}
                  <tr>
                    <td>Visa Approved</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalVisaApproved?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download visa approved report"
                        )
                      }
                    >
                      {totalStudents.totalVisaApproved?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeVisaApproved?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download active visa approved report"
                        )
                      }
                    >
                      {totalStudents.activeVisaApproved?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalVisaApproved?.count}</td>
                            <td>{record.data.activeVisaApproved?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Visa rejected */}
                  <tr>
                    <td>Visa rejected</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalVisaRejected?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download visa rejected report"
                        )
                      }
                    >
                      {totalStudents.totalVisaRejected?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeVisaRejected?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download active visa rejected report"
                        )
                      }
                    >
                      {totalStudents.activeVisaRejected?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalVisaRejected?.count}</td>
                            <td>{record.data.activeVisaRejected?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  <tr>
                    <td
                      colSpan={3}
                      className="py-1 "
                      style={{ background: "#f9f9f9" }}
                    ></td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td
                              colSpan={2}
                              className="py-1 "
                              style={{ background: "#f9f9f9" }}
                            ></td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Registration Paid - Visa Cases */}
                  <tr>
                    <th>Registration Paid - Visa Cases</th>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalRegPaidVisaCases?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download registration paid visa cases report"
                        )
                      }
                    >
                      {totalStudents.totalRegPaidVisaCases?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeRegPaidVisaCases?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download active registration paid visa cases report"
                        )
                      }
                    >
                      {totalStudents.activeRegPaidVisaCases?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalRegPaidVisaCases?.count}</td>
                            <td>{record.data.activeRegPaidVisaCases?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Partial filled */}
                  <tr>
                    <td>Partially Filled</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalRegPaidPartialFilled?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download partially filled visa cases report"
                        )
                      }
                    >
                      {totalStudents.totalRegPaidPartialFilled?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeRegPaidPartialFilled?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download active partially filled visa cases report"
                        )
                      }
                    >
                      {totalStudents.activeRegPaidPartialFilled?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalRegPaidPartialFilled?.count}
                            </td>
                            <td>
                              {record.data.activeRegPaidPartialFilled?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* File Launched */}
                  <tr>
                    <td>File Launched</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalRegPaidFileLaunched?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download file launched visa cases report"
                        )
                      }
                    >
                      {totalStudents.totalRegPaidFileLaunched?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeRegPaidFileLaunched?.query,
                          exportReportQuery.visa_booked.total,
                          "Do you want to download active file launched visa cases report"
                        )
                      }
                    >
                      {totalStudents.activeRegPaidFileLaunched?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalRegPaidFileLaunched?.count}
                            </td>
                            <td>
                              {record.data.activeRegPaidFileLaunched?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  <tr>
                    <td
                      colSpan={3}
                      className="py-1 "
                      style={{ background: "#f9f9f9" }}
                    ></td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td
                              colSpan={2}
                              className="py-1 "
                              style={{ background: "#f9f9f9" }}
                            ></td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Alumni */}
                  <tr>
                    <th>Alumni</th>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAlumuni?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download alumni report"
                        )
                      }
                    >
                      {totalStudents.totalAlumuni?.count || 0}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAlumuni?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download active alumni report"
                        )
                      }
                    >
                      {totalStudents.activeAlumuni?.count || 0}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalAlumuni?.count || 0}</td>
                            <td>{record.data.activeAlumuni?.count || 0}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Yes Buddy */}
                  <tr>
                    <td>Yes Buddy</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalYesBuddy?.query,
                          exportReportQuery.yes_buddy.total,
                          "Do you want to download yes buddy report"
                        )
                      }
                    >
                      {totalStudents.totalYesBuddy?.count || 0}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeYesBuddy?.query,
                          exportReportQuery.yes_buddy.total,
                          "Do you want to download active yes buddy report"
                        )
                      }
                    >
                      {totalStudents.activeYesBuddy?.count || 0}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalYesBuddy?.count}</td>
                            <td>{record.data.activeYesBuddy?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Yes Bestie */}
                  <tr>
                    <td>Yes Bestie</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalYesBestie?.query,
                          exportReportQuery.yes_buddy.total,
                          "Do you want to download yes bestie report"
                        )
                      }
                    >
                      {totalStudents.totalYesBestie?.count || 0}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeYesBestie?.query,
                          exportReportQuery.yes_buddy.total,
                          "Do you want to download active yes bestie report"
                        )
                      }
                    >
                      {totalStudents.activeYesBestie?.count || 0}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalYesBestie?.count || 0}</td>
                            <td>{record.data.activeYesBestie?.count || 0}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Yes Ambasador */}
                  <tr>
                    <td>Yes Ambasador</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalYesAmbasador?.query,
                          exportReportQuery.yes_buddy.total,
                          "Do you want to download yes ambasador report"
                        )
                      }
                    >
                      {totalStudents.totalYesAmbasador?.count || 0}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeYesAmbasador?.query,
                          exportReportQuery.yes_buddy.total,
                          "Do you want to download active yes ambasador report"
                        )
                      }
                    >
                      {totalStudents.activeYesAmbasador?.count || 0}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalYesAmbasador?.count || 0}</td>
                            <td>
                              {record.data.activeYesAmbasador?.count || 0}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Yes Family */}
                  <tr>
                    <td>Yes Family</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalYesFamily?.query,
                          exportReportQuery.yes_buddy.total,
                          "Do you want to download yes family report"
                        )
                      }
                    >
                      {totalStudents.totalYesFamily?.count || 0}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeYesFamily?.query,
                          exportReportQuery.yes_buddy.total,
                          "Do you want to download active yes family report"
                        )
                      }
                    >
                      {totalStudents.activeYesFamily?.count || 0}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalYesFamily?.count || 0}</td>
                            <td>{record.data.activeYesFamily?.count || 0}</td>
                          </>
                        );
                      })}
                  </tr>

                  <tr>
                    <td
                      colSpan={3}
                      className="py-1 "
                      style={{ background: "#f9f9f9" }}
                    ></td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td
                              colSpan={2}
                              className="py-1 "
                              style={{ background: "#f9f9f9" }}
                            ></td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Total Payment Due */}
                  {/* Payment Completed */}
                  <tr>
                    <th>Payment Completed</th>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalPaymentCompleted?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download payment completed report"
                        )
                      }
                    >
                      {totalStudents.totalPaymentCompleted?.count}
                    </td>

                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activePaymentCompleted?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download active payment completed report"
                        )
                      }
                    >
                      {totalStudents.activePaymentCompleted?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalPaymentCompleted?.count}</td>
                            <td>{record.data.activePaymentCompleted?.count}</td>
                          </>
                        );
                      })}
                  </tr>
                  {/* Admission Amount Pending */}
                  <tr>
                    <th>Registration Amount Due</th>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalRegAmountPending?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download registration amount pending report"
                        )
                      }
                    >
                      {totalStudents.totalRegAmountPending?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeRegAmountPending?.query,
                          exportReportQuery.totalStudentsReport.total,
                          "Do you want to download active registration amount pending report"
                        )
                      }
                    >
                      {totalStudents.activeRegAmountPending?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalRegAmountPending?.count}</td>
                            <td>{record.data.activeRegAmountPending?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Admission Amount Pending */}
                  <tr>
                    <td>Admission Amount Due</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmAmountPending?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download admission amount pending report"
                        )
                      }
                    >
                      {totalStudents.totalAdmAmountPending?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmAmountPending?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download admission amount pending report"
                        )
                      }
                    >
                      {totalStudents.activeAdmAmountPending?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalAdmAmountPending?.count}</td>
                            <td>{record.data.activeAdmAmountPending?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Public */}
                  <tr>
                    <td className="text-end">Public Category</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmAmountPendingPublic?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download public report"
                        )
                      }
                    >
                      {totalStudents.totalAdmAmountPendingPublic?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmAmountPendingPublic?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download active public report"
                        )
                      }
                    >
                      {totalStudents.activeAdmAmountPendingPublic?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalAdmAmountPendingPublic?.count}
                            </td>
                            <td>
                              {record.data.activeAdmAmountPendingPublic?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Private */}
                  <tr>
                    <td className="text-end">Private Category</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmAmountPendingPrivate?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download private report"
                        )
                      }
                    >
                      {totalStudents.totalAdmAmountPendingPrivate?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmAmountPendingPrivate?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download private report"
                        )
                      }
                    >
                      {totalStudents.activeAdmAmountPendingPrivate?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalAdmAmountPendingPrivate?.count}
                            </td>
                            <td>
                              {record.data.activeAdmAmountPendingPrivate?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Other */}
                  <tr>
                    <td className="text-end">Other Category</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAdmAmountPendingOther?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download other report"
                        )
                      }
                    >
                      {totalStudents.totalAdmAmountPendingOther?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmAmountPendingOther?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download active other report"
                        )
                      }
                    >
                      {totalStudents.activeAdmAmountPendingOther?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalAdmAmountPendingOther?.count}
                            </td>
                            <td>
                              {record.data.activeAdmAmountPendingOther?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>
                  {/* Public Admission From Other Category */}
                  <tr>
                    <td className="text-end">Public Admission From Other Category</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalPublicAdmAmountPendingOther?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download Public Admission From Other Category report"
                        )
                      }
                    >
                      {totalStudents.totalPublicAdmAmountPendingOther?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activePublicAdmAmountPendingOther?.query,
                          exportReportQuery.admission_applied.total,
                          "Do you want to download active Public Admission From Other Category report"
                        )
                      }
                    >
                      {totalStudents.activePublicAdmAmountPendingOther?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalPublicAdmAmountPendingOther?.count}
                            </td>
                            <td>
                              {record.data.activePublicAdmAmountPendingOther?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Visa Amount Pending */}
                  <tr>
                    <td>Visa Amount Due</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAdmAmountPending?.query,
                          exportReportQuery.aps_applied.total,
                          "Do you want to download visa amount pending report"
                        )
                      }
                    >
                      {totalStudents.totalVisaPending?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeVisaPending?.query,
                          exportReportQuery.aps_applied.total,
                          "Do you want to download active visa amount pending report"
                        )
                      }
                    >
                      {totalStudents.activeVisaPending?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalVisaPending?.count}</td>
                            <td>{record.data.activeVisaPending?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Accomodation Amount Pending */}
                  <tr>
                    <td>Accomodation Amount Due</td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.totalAccomodationPending?.query,
                          exportReportQuery.aps_applied.total,
                          "Do you want to download accomodation amount pending report"
                        )
                      }
                    >
                      {totalStudents.totalAccomodationPending?.count}
                    </td>
                    <td
                      className="text-nowrap cursor-pointer"
                      onClick={() =>
                        fetchDataByQuery(
                          totalStudents.activeAccomodationPending?.query,
                          exportReportQuery.aps_applied.total,
                          "Do you want to download active accomodation amount pending report"
                        )
                      }
                    >
                      {totalStudents.activeAccomodationPending?.count}
                    </td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>
                              {record.data.totalAccomodationPending?.count}
                            </td>
                            <td>
                              {record.data.activeAccomodationPending?.count}
                            </td>
                          </>
                        );
                      })}
                  </tr>

                  <tr>
                    <td
                      colSpan={3}
                      className="py-1 "
                      style={{ background: "#f9f9f9" }}
                    ></td>
                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td
                              colSpan={2}
                              className="py-1 "
                              style={{ background: "#f9f9f9" }}
                            ></td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Total YG Mails Recieved */}
                  <tr>
                    <th>Total YG Mails Recieved</th>
                    <td>{totalStudents.totalYgMailRecieved?.count}</td>
                    <td>{totalStudents.activeYgMailRecieved?.count}</td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalYgMailRecieved?.count}</td>
                            <td>{record.data.activeYgMailRecieved?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Trackers Done */}
                  <tr>
                    <td>Trackers Done</td>
                    <td>{totalStudents.totalTrackerDone?.count}</td>
                    <td>{totalStudents.activeTrackerDone?.count}</td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalTrackerDone?.count}</td>
                            <td>{record.data.activeTrackerDone?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Open todos */}
                  <tr>
                    <td>Open todos</td>
                    <td>{totalStudents.totalOpenTodos?.count}</td>
                    <td>{totalStudents.activeOpenTodos?.count}</td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalOpenTodos?.count}</td>
                            <td>{record.data.activeOpenTodos?.count}</td>
                          </>
                        );
                      })}
                  </tr>

                  {/* Overdue todos */}
                  <tr>
                    <td className="text-danger">Overdue todos</td>
                    <td>{totalStudents.totalPrivate?.count}</td>
                    <td>{totalStudents.activePrivate?.count}</td>

                    {totalStudentsMark2 &&
                      totalStudentsMark2.map((record, key) => {
                        return (
                          <>
                            <td>{record.data.totalPrivate?.count}</td>
                            <td>{record.data.activePrivate?.count}</td>
                          </>
                        );
                      })}
                  </tr>
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      <Modal
        show={askSavedNow}
        size="md"
        centered
        onHide={() => setAskSavedNow(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Save Table</Modal.Title>
        </Modal.Header>
        <form onSubmit={(e) => { saveMondayMeetingData(e); }}>
          <Modal.Body>
            <input type="text" className="form-control" required placeholder="Name of Table" onChange={(e) => setEventName(e.target.value)} />
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-center w-100 gap-3">
              <input type="submit" value={"Save Now"} className="btn btn-sm rounded btn-dark w-100" style={{ maxWidth: "120px" }} />
            </div>
          </Modal.Footer>
        </form>
      </Modal>


      <Modal
        show={askToDeleteTableRecord}
        size="md"
        centered
        onHide={() => setAskToDeleteTableRecord(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 text-center">
          <div className="alert alert-danger m-0">
            Are you sure you want to delete <b>{idToDeleteTable?.label}</b>?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center w-100 gap-3">
            <input type="button" value={"Delete Now"} className="btn btn-sm rounded btn-danger w-100" style={{ maxWidth: "120px" }} onClick={() => { handleDeleteDate(idToDeleteTable?.value) }} />
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={addComparisonTable}
        size="md"
        centered
        onHide={() => setAddComparisonTable(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Table to Compare</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-yesgermany m-0" >
            <thead>
              <tr align="middle">
                <th>
                  <input
                    className="form-check-input checkBoxAllControl"
                    type="checkbox"
                    onChange={(e) => {
                      if (e.target.checked) {
                        console.log("checked")
                        setAllDatesSelected(true);
                        handleAllDatesSelection(true)
                      } else {
                        console.log("unchecked")
                        setAllDatesSelected(false);
                        handleAllDatesSelection(false)
                      }
                    }}
                    defaultChecked={allDatesSelected ? true : false}
                  />
                </th>
                <th>Name</th>
                <th>Added On</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {
                dateOptions?.map((date, index) => (
                  <tr key={index} align="middle">
                    <td>
                      <input
                        className="form-check-input tableCompareClass"
                        type="checkbox"
                        value={date}
                        id={`dateOption${index}`}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedDate([...selectedDate, date]);
                          } else {
                            setSelectedDate(selectedDate.filter(d => d !== date));
                            setAllDatesSelected(false);
                            document.querySelector('.checkBoxAllControl').checked = false;

                          }
                        }}
                        defaultChecked={selectedDate?.includes(date) ? true : false}
                      />
                    </td>
                    <td>
                      <label className="form-check-label" htmlFor={`dateOption${index}`}>
                        {date.label}
                      </label>
                    </td>
                    <td>{dayjs(date.data.createdAt).format("D MMM YYYY")}</td>
                    <td>
                      <i className="fa fa-trash text-danger cursor-pointer" onClick={() => { setAskToDeleteTableRecord(true); setIdToDeleteTable(date); }}></i>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>

        </Modal.Body>
      </Modal>
    </>
  );
}

export default StudentFunnel;
